import React from 'react';
import { KanaTable } from './KanaTable';
import { ErrorMessage } from '@hookform/error-message';
import { FieldErrors, UseFormRegister } from 'react-hook-form';
import { BankAccountFormData } from '@js/interfaces';

type Props = {
  onUpdateInitial: (label: 'bank' | 'branch') => void
  register: UseFormRegister<BankAccountFormData>
  errors: FieldErrors<BankAccountFormData>
}

export const BankNameInitials = (props: Props) => {
  const { onUpdateInitial, register, errors } = props;
  const fieldLabel = 'bank';

  return (
    <div className="bank-account">
      <div className="bank-account__heading">
        金融機関の選択
      </div>
      <div className="bank-account__lead">
        金融機関の頭文字を選択してください。
      </div>
      <div className="bank-account__initial">
        <KanaTable register={register} fieldLabel={fieldLabel} />
        <ErrorMessage
          errors={errors}
          name="kana_table_bank"
          render={({ message }) =>
            <span className="form-input__error">金融機関の{message}</span>}
        />
      </div>
      <div className="layout-flex--center bank-account__button-layout">
        <button onClick={(e) => {e.stopPropagation(); onUpdateInitial(fieldLabel); e.stopPropagation();}} type="button" className="button-base--action button-w344">
          次へ進む
          <i className="material-icons button-icon-right flip-horizontal">keyboard_backspace</i>
        </button>
      </div>
    </div>
  );
};
